import { Component } from '@angular/core';

@Component({
  selector: 'app-absence-popup',
  templateUrl: './absence-popup.component.html',
  styleUrl: './absence-popup.component.scss',
  standalone: false,
})
export class AbsencePopupComponent {}
